import React, { useMemo, useCallback } from "react";
import Card from "components/CardSelector/Card";
import { BenefitsContainer } from "./styles";

function BenefitSetupSidebar({
  selectedBenefit,
  selectedBenefits,
  onBenefitClick,
  benefits,
  completedProducts,
}) {
  const sortedBenefits = useMemo(() => {
    return benefits?.filter(({ id }) => selectedBenefits?.includes(id)) || [];
  }, [selectedBenefits, benefits]);

  const cardItems = useMemo(() => {
    return sortedBenefits.map(({ display_name, id }, index) => {
      const isCompleted = completedProducts?.has(id) || false;
      const isSelected = String(selectedBenefit) === String(id); // Convert both to strings for comparison
      
      return {
        id,
        display_name,
        isCompleted,
        isSelected,
        title: `${display_name}${isCompleted ? ' ✓' : ''}`,
        style: {
          backgroundColor: isCompleted ? '#e8f5e8' : isSelected ? '#f0f0f0' : 'white',
          border: isSelected ? '2px solid #007bff' : '1px solid #ddd',
        }
      };
    });
  }, [sortedBenefits, selectedBenefit, completedProducts]);

  const handleBenefitClick = useCallback((id) => {
    onBenefitClick(null, id);
  }, [onBenefitClick]);

  // Removed isProductAccessible function as it's no longer needed

  if (!selectedBenefits) return null;
  return (
    <aside>
      <BenefitsContainer vertical>
        {cardItems.map((card) => (
          <Card
            fullWidth
            key={card.id}
            title={card.title}
            selected={card.isSelected}
            onChange={() => {
              handleBenefitClick(card.id);
            }}
            style={card.style}
          />
        ))}
      </BenefitsContainer>
    </aside>
  );
}

export default BenefitSetupSidebar;
